module.exports = __webpack_public_path__ + "img/fin_ill_3.9dfad373.png";